import styled, { css } from 'styled-components';
import { WrapperDefault } from '../../Shared/Shared';

export const FormInfoWrapper = styled(WrapperDefault)`
  padding-bottom: 0;
  @media (max-width: 1200px) {
    width: 100%;
    padding: 0;
  }
`;

export const FormInfoContainer = styled.div<{ marginBottom?: string }>`
  margin-top: 30px;
  margin-bottom: ${({ marginBottom }) => marginBottom || '30px'};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const FormTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Title = styled.span`
  font-size: 18px;
  font-weight: 800;
`;

export const Description = styled.p<{ crossed?: boolean; color?: string; bold?: boolean; size?: number }>`
  font-size: 18px;
  font-weight: 500;
  white-space: pre-line;
  line-height: 1.5;
  color: ${({ color }) => color || 'var(--text-primary)'};
  ${({ bold }) =>
    bold &&
    css`
      font-weight: 800;
    `}

  ${({ crossed }) =>
    crossed &&
    css`
      text-decoration: line-through;
      font-weight: 800;
    `}

  ${({ size }) =>
    size &&
    css`
      font-size: ${size}px;
    `}
`;

export const Checkbox = styled.span<{ checked?: boolean }>`
  width: 30px;
  height: 30px;
  border-radius: 9px;
  border: solid 2px var(--black);
  display: flex;
  justify-content: center;
  align-items: center;
  svg {
    fill: ${props => (props.checked ? 'var(--dark-gray)' : 'transparent')};
    stroke: ${props => (props.checked ? 'var(--white)' : 'transparent')};
  }
`;

export const PaymentDescription = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-primary);
`;

export const CheckboxContainer = styled.label<{ mobileWidth?: string; width?: string }>`
  display: flex;
  align-items: center;
  gap: 10px;
  width: ${({ width }) => width || '200px'};
  user-select: none;
  cursor: pointer;
  font-size: 18px;
  font-weight: 600;
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;

    &:checked ~ ${Checkbox} {
      svg {
        fill: var(--dark-gray);
        stroke: var(--dark-gray);
      }
    }
  }
  @media (max-width: 768px) {
    width: ${({ mobileWidth }) => mobileWidth || '100%'};
  }
`;

export const PriceContainer = styled.div<{ column?: boolean }>`
  display: flex;
  gap: 8px;
  ${({ column }) =>
    column &&
    css`
      flex-direction: column;
    `};
`;

export const ClearButton = styled.button`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 12px;
  background: var(--white);
  border: none;
  cursor: pointer;
  user-select: none;
  margin: 0;
  padding: 0;
  span {
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
  }
`;
export const DiscountInputWrapper = styled.div``;

export const DiscountInputContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 10px;
`;

export const DescriptionBox = styled.div`
  height: 200px;
  width: 100%;
  overflow-y: scroll;
  background: transparent;
`;
// display: 'flex', fontSize: 14, marginBottom: 20, marginTop: 20, gap: 4
export const AgreementText = styled.span`
  display: flex;
  font-size: 14px;
  margin-bottom: 20px;
  margin-top: 20px;
  gap: 4px;
  @media (max-width: 768px) {
    width: auto;
    max-width: 400px;
  }
`;
